import { render, staticRenderFns } from "./DocumentSignatureDropZoneCard.vue?vue&type=template&id=830956be"
import script from "./DocumentSignatureDropZoneCard.vue?vue&type=script&lang=js"
export * from "./DocumentSignatureDropZoneCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports